import { render, staticRenderFns } from "./pos-ask-origin-modal.vue?vue&type=template&id=e27a0d8e&scoped=true&"
import script from "./pos-ask-origin-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-ask-origin-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27a0d8e",
  null
  
)

export default component.exports